import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactReminder } from 'src/app/domain/IContactActivity';
import { getTaskPriorityDescriptionById } from 'src/app/domain/registration/enums/task-priority.enum';

@Component({
    selector: 'app-reminder-notification-modal',
    templateUrl: './reminder-notification-modal.component.html',
    styleUrls: ['./reminder-notification-modal.component.sass']
})
export class ReminderNotificationModalComponent {

    reminder: ContactReminder;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ContactReminder,
        private dialogRef: MatDialogRef<ReminderNotificationModalComponent>
    ) {
        this.reminder = data;
    }

    // Função auxiliar para obter nome da categoria, se existir
    getCategoryName(): string | undefined {
        // Se a categoria veio aninhada (melhor caso)
        if (this.reminder.category && typeof this.reminder.category === 'object') {
            return this.reminder.category.name;
        }
        // Se veio apenas o ID (precisaria buscar, mas para o modal vamos simplificar)
        // Ou se não tem categoria
        return undefined;
    }

    // Função para obter descrição da prioridade (caso seja uma Tarefa, embora este modal seja para Lembrete)
    getPriorityDescription(priorityId: number | string | undefined): string {
        if (priorityId === undefined) return 'Não definida';
        const numericId = typeof priorityId === 'string' ? parseInt(priorityId, 10) : priorityId;
        return getTaskPriorityDescriptionById(numericId) || 'Desconhecida';
    }

    close(): void {
        this.dialogRef.close();
    }
} 